import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IDomainResponseData} from '../../interfaces/IDomainResponse';
import {BaseService} from "../caronte-base/base.service";
import {RouteUtils} from "../../../utils/route.utils";

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  constructor(private baseService: BaseService) {
  }

  getDomainResponseList(): Observable<IDomainResponseData> {
    return this.baseService
      .get<IDomainResponseData>(RouteUtils.ENTRYPOINTS.GET_PROFESSIONS);
  }
}
